import useAssets from '../../../../../common/useAssets';
const cdn = useAssets(false);

let arrayList = []
for (let i = 1; i < 34; i++) {
    arrayList.push(cdn(`images/sharing/koc/k${i}.png`))
}

export const imgList = arrayList